import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { RecaptchaModule } from 'angular-google-recaptcha';
import { IntegradorModule } from './../../resources/modules/integrador.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './../../resources/configuracion/material.module';
import { HttpClientModule } from '@angular/common/http';

import { HabilitarCuentaRoutingModule } from './habilitar-cuenta-routing.module';
import { ContenedorComponent } from './components/contenedor/contenedor.component';
import { CambiarPassComponent } from './components/cambiar-pass/cambiar-pass.component';
import { AutenticacionComponent } from './components/autenticacion/autenticacion.component';
import { environment } from './../../../environments/environment';
import { MenuComponent } from './components/menu/menu.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';

@NgModule({
  imports: [
    CommonModule,
    HabilitarCuentaRoutingModule,
    BrowserModule,
    HttpModule, 
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    IntegradorModule,
    RecaptchaModule.forRoot({
      siteKey: environment.captchaKey
    })
  ],
  declarations: [
    ContenedorComponent,
    AutenticacionComponent,    
    CambiarPassComponent, 
    MenuComponent,
    ConfirmacionComponent    
  ]
})
export class HabilitarCuentaModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/habilitar-cuenta.module.ts